import React from 'react';
import { FaCar, FaChevronUp, FaChevronDown, FaListAlt, FaCoffee, FaUtensils, FaMoon } from 'react-icons/fa';

const ItineraryTimeline = ({ itineraryRef, days, activeDay, handleDayClick }) => (
  <div ref={itineraryRef} id="itinerary-section" className="timeline-itinerary">
    <h2><FaListAlt /> Tour Itinerary</h2>
    <div className="timeline-list">
      {days.map((day, idx) => (
        <div
          key={day.day}
          className={`timeline-item${activeDay === day.day ? ' active' : ''}`}
          onClick={() => handleDayClick(activeDay === day.day ? null : day.day)}
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            marginBottom: '10px',
            padding: '10px',
            background: activeDay === day.day ? '#fafbfc' : '#fff',
            boxShadow: activeDay === day.day ? '0 2px 8px rgba(0,0,0,0.04)' : 'none',
            cursor: 'pointer',
            transition: 'box-shadow 0.2s, background 0.2s'
          }}
        >
          <div className="timeline-marker">
            <span className="timeline-dot">{day.day}</span>
            {idx < days.length - 1 && <span className="timeline-line"></span>}
          </div>
          <div className="timeline-summary">
            <div className="timeline-title" style={{ justifyContent: "flex-start", textAlign: "left" }}>
              <span className="timeline-icon">
                {day.activities && (
                  day.activities.includes("Drive to Gulmarg") || day.activities.includes("Drive to Pahalgam") || day.activities.includes("Drive to Sonmarg") ? (
                    <FaCar />
                  ) : day.activities.includes("Airport Transfer") ? (
                    <FaCar />
                  ) : null
                )}
              </span>
              <span>Day {day.day}: {day.title}</span>
              <span className="timeline-expand-icon">
                {activeDay === day.day ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
            {activeDay === day.day && (
              <div className="creative-details-card">
                <div className="creative-details-bar"></div>
                <div className="creative-details-content">
                  <div className="creative-details-header">
                    <span className="creative-details-daynum">{day.day}</span>
                    <div>
                      <div className="creative-details-title">{day.title}</div>
                      {/* Meals details below title */}
                      <div className="creative-details-meals" style={{ marginTop: 4 }}>
                        {day.meals && (day.meals.B || day.meals.L || day.meals.D) && (
                          <>
                            {day.meals.B && (
                              <span title="Breakfast Included" style={{ marginRight: 10 }}>
                                <FaCoffee /> Breakfast
                              </span>
                            )}
                            {day.meals.L && (
                              <span title="Lunch Included" style={{ marginRight: 10 }}>
                                <FaUtensils /> Lunch
                              </span>
                            )}
                            {day.meals.D && (
                              <span title="Dinner Included">
                                <FaMoon /> Dinner
                              </span>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="creative-details-desc">
                    <ul>
                      {day.description
                        .split('.')
                        .map(line => line.trim())
                        .filter(line => line.length > 0)
                        .map((line, i) => (
                          <li key={i}>{line}.</li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ItineraryTimeline;
